import { sendRequest } from 'best-modules/utils'

export type HelpGuide = {
  title: string
  html: string
}

export const getHelpGuide = (guide: string): Promise<HelpGuide> => {
  return sendRequest({
    name: 'helpGuide',
    url: `/admin/help/${guide}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })
}
